import { z } from 'zod';

/**
 * What a violation is *about* — the discriminator on `moderation.violations`.
 *
 * Until P27 every violation was one message judged against one type, and the
 * table was named for it. A behavioural flag (mass-like velocity, rapid
 * match-cycling, message spam) has **no message**: it is an account and a
 * counted pattern. It shares the whole lifecycle after that — status, action,
 * enforcement claim, appeal, verdict — so it is a second *subject* on one
 * record, never a second table: the queue pages one list oldest-first through
 * the base repository, and `EnforcementService` is the one door to a
 * consequence (N20).
 */
export const VIOLATION_SUBJECT_KINDS = ['message', 'behavior'] as const;

export const ViolationSubjectKindSchema = z.enum(VIOLATION_SUBJECT_KINDS);

export type ViolationSubjectKind = (typeof VIOLATION_SUBJECT_KINDS)[number];

/**
 * Does this kind carry a message?
 *
 * One spelling, because the answer gates four different things — the CHECK
 * binding `message_id`, the evidence a reviewer is shown, whether
 * `hide_message` is a possible consequence, and which claim index applies — and
 * a predicate written out longhand in four places is four places to forget a
 * third kind.
 */
export function isMessageSubjectKind(kind: ViolationSubjectKind): boolean {
  return kind === 'message';
}
